import React from 'react'
// import moment from 'moment'
import { InputGroup, Intent, FormGroup } from '@blueprintjs/core'
import { DateInput2 } from '@blueprintjs/datetime2'
import { HRLocationSelect } from '@ui'
import { FormBuilding, BuildingFormErrors } from './BuildingForm'
import { BTSelect } from '@ui/selects/BuildingTypeSelect'
import { DateUtil, TIME } from '@utils'

interface IRow {
  label?: string
  required?: boolean
  formEl: (
    building: FormBuilding,
    update: (key: string, value: any) => void,
    errors: BuildingFormErrors
  ) => React.ReactNode
}

export const rows: IRow[] = [
  {
    label: 'Name',
    required: true,
    formEl: (building, update, errors) => (
      <FormGroup
        {...{
          helperText: errors.name,
          intent: errors.name ? Intent.DANGER : undefined,
          style: { width: '100%' },
        }}
      >
        <InputGroup
          autoFocus
          value={building.name}
          onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) =>
            update('name', value)
          }
        />
      </FormGroup>
    ),
  },
  {
    label: 'Address',
    required: true,
    formEl: (building, update, errors) => (
      <FormGroup
        {...{
          helperText: errors.address,
          intent: errors.address ? Intent.DANGER : undefined,
          style: { width: '100%' },
        }}
      >
        <InputGroup
          value={building.address}
          onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) =>
            update('address', value)
          }
        />
      </FormGroup>
    ),
  },
  {
    label: 'Code',
    required: true,
    formEl: (building, update, errors) => (
      <FormGroup
        {...{
          helperText: errors.code,
          intent: errors.code ? Intent.DANGER : undefined,
          style: { width: '100%' },
        }}
      >
        <InputGroup
          value={building.code}
          onChange={({ target: { value } }: React.ChangeEvent<HTMLInputElement>) =>
            update('code', value)
          }
        />
      </FormGroup>
    ),
  },
  {
    label: 'HR Location',
    required: true,
    formEl: (building, update, errors) => (
      <FormGroup
        {...{
          helperText: errors.geoLocation,
          intent: errors.geoLocation ? Intent.DANGER : undefined,
          style: { width: '100%' },
        }}
      >
        <HRLocationSelect
          value={building.geoLocation}
          onChange={(hrLocation) => update('geoLocation', hrLocation)}
        />
      </FormGroup>
    ),
  },
  {
    label: 'End Date',
    formEl: (building, update, errors) => (
      <DateInput2
        parseDate={(dateStr) => DateUtil(dateStr, 'MM/dd/yyyy').toDate()}
        formatDate={(date) => DateUtil(date).format('MMM dd, yyyy')}
        popoverProps={{ minimal: true, position: 'bottom' }}
        value={building.closedAt ? DateUtil(building.closedAt).toString() : null}
        onChange={(selectedDate) => update('closedAt', selectedDate)}
        minDate={DateUtil().sub(5, TIME.YEARS).toDate()}
        maxDate={DateUtil().add(10, TIME.YEARS).toDate()}
      />
    ),
  },
  {
    label: 'Building Type',
    formEl: (building, update, errors) => (
      <BTSelect
        values={building.buildingType ? [building.buildingType] : undefined}
        onChange={(buildingType) => update('buildingType', buildingType)}
        buttonProps={{
          blue: false,
          text: 'Select',
        }}
      />
    ),
  },
]
